import axios from 'axios';
import apiClient from './api';
import {
  AgentAsyncInitResponse,
  AgentChatRequest,
  AgentJobStatusResponse,
} from '@/types/agent.types';
import { HttpError } from '@/errors/HttpError';

/** El POST de inicio debe resolver rápido (solo encola el job en el BFF). */
const INIT_TIMEOUT_MS = 15_000;

export const AGENT_ASK_PATH = '/agent/ask';

export async function postAgentChatInit(
  pregunta: string,
  sessionId?: string | null
): Promise<AgentAsyncInitResponse> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), INIT_TIMEOUT_MS);

  try {
    const body: AgentChatRequest = { question: pregunta };
    if (sessionId) {
      body.session_id = sessionId;
    }
    const { data } = await apiClient.post<AgentAsyncInitResponse>(AGENT_ASK_PATH, body, {
      signal: controller.signal,
    });
    return data;
  } catch (err: unknown) {
    if (axios.isAxiosError(err) && err.code === 'ERR_CANCELED') {
      throw new HttpError('Request aborted (timeout)', 408, {
        detail: 'The server took more than 15s to start the task. Please retry.',
      });
    }
    throw err;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

/** Consulta estado del job; `poll_url` la devuelve el BFF (no construir a mano). */
export async function getAgentJobStatus(
  pollUrl: string,
  signal?: AbortSignal
): Promise<AgentJobStatusResponse> {
  const url = pollUrl.trim();
  const { data } = await apiClient.get<AgentJobStatusResponse>(url, { signal });
  return data;
}
